import { useTranslation } from 'react-i18next';

import { KountAccessWarning } from '@airtm/airtm-ui';

import {
  VerifyKountDevice as VERIFY_KOUNT_DEVICE,
  SendKountDeviceVerificationCodeMutation as SEND_KOUNT_VERIFICATION_CODE,
} from 'graphqlDocuments/mutations';
import {
  VerifyKountDevice,
  VerifyKountDeviceVariables,
} from 'graphqlDocuments/mutations/__generated__/VerifyKountDevice';
import { useMutation } from '@apollo/client/react';
import { useToast } from 'utils/hooks/useToast';
import EmailCodeVerification from 'components/EmailCodeVerification';

export function VerifyKount({
  kountIp,
  onVerified,
}: Readonly<{ kountIp: string; onVerified: () => void }>) {
  const { t } = useTranslation(['SIGNUP', 'SETTINGS', 'LOGIN']);
  const { toast } = useToast();

  const [verifyKountDevice] = useMutation<VerifyKountDevice, VerifyKountDeviceVariables>(
    VERIFY_KOUNT_DEVICE,
  );
  const [sendKountVerificationCode] = useMutation(SEND_KOUNT_VERIFICATION_CODE);

  return (
    <>
      <h1>{t('LOGIN:LOGIN_KOUNT_UNKNOWN_TITLE')}</h1>

      <KountAccessWarning
        kountIp={kountIp}
        textHead={t('LOGIN:KOUNT_UNKNOWN')}
        textBody={t('LOGIN:KOUNT_IP', { ip: '' })}
        textFoot={t('LOGIN:KOUNT_CHECK_INBOX')}
      />
      <EmailCodeVerification
        onSubmit={async ({ verificationCode }) => {
          await verifyKountDevice({
            variables: {
              code: verificationCode,
            },
          });
          toast({
            title: t('LOGIN:KOUNT_WHITELISTED'),
            message: t('LOGIN:KOUNT_LOGIN'),
            type: 'success',
          });
          onVerified();
        }}
        onResend={async () => {
          await sendKountVerificationCode();
        }}
        className="mt-12"
      />
    </>
  );
}

export default VerifyKount;
